import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-azosis-dark flex items-center justify-center px-6">
      <div className="text-center">
        <div className="font-display text-8xl md:text-9xl font-bold text-azosis-gold/20 mb-4">
          404
        </div>
        <h1 className="font-display text-2xl md:text-3xl font-bold text-white mb-4">
          Page Not Found
        </h1>
        <p className="text-azosis-textSecondary text-base mb-8 max-w-md mx-auto">
          The page you are looking for does not exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-azosis-gold text-azosis-dark font-semibold text-sm tracking-wide hover:bg-azosis-goldLight transition-all duration-300"
        >
          <i className="ri-arrow-left-line"></i>
          Back to Home
        </Link>
      </div>
    </div>
  );
}
